import { render, staticRenderFns } from "./natural.vue?vue&type=template&id=1635a35f&scoped=true&"
import script from "./natural.vue?vue&type=script&lang=js&"
export * from "./natural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635a35f",
  null
  
)

export default component.exports